import mapActions from "actions/map";
import profileActions from "actions/profile";
import { connect, generatedActions, viewDispatchToProps, viewStateToProps } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => {
        return {
            ...viewStateToProps(state),
            mapBid: state.map.data.currentBid,
            workRestInfo: state.profile.workRestInfo,
            refuelingServiceType: state.profile.organization.refuelingServiceType,
            refuelingSettings: state.profile.refuelingSettings,
        };
    };
    const mapDispatch = (dispatch) => {
        return {
            ...viewDispatchToProps(dispatch),
            mergeAllParams: (params) => dispatch(generatedActions.bids.merge(params)),
            mergeParams: (params) => dispatch(generatedActions.bids.merge(params)),
            mergeMapHeader: (data) => dispatch(mapActions.mergeMapHeader(data)),
            mergeMapViewport: (data) => dispatch(mapActions.mergeMapViewport(data)),
            mergeNotifysParams: (params) => dispatch(generatedActions.chats.merge(params)),
            mergeMapData: (data) => dispatch(mapActions.mergeMapData(data)),
            getWorkRestInfo: () => dispatch(profileActions.getWorkRestInfo()),
        };
    };
    return connect(mapState, mapDispatch)(Component);
}
